import {useState, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {setModalQR} from '../../reducers/app/actions';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Copy from '../components/copy';

export default ({data}) => {
    const dispatch = useDispatch(),
          [close, setClose] = useState(false);
    
    const blur = useRef(),
          modal = useRef();

    const closeHandler = () => {
        if(close)
            return;

        setClose(true);

        if(blur.current) {
            blur.current.classList.remove('animate__animated');
            blur.current.classList.remove('animate__fadeIn');
            blur.current.classList.add('animate__fadeOut');
            blur.current.classList.add('animate__animated');
        }

        if(modal.current) {
            modal.current.classList.remove('animate__animated');
            modal.current.classList.remove('animate__fadeInUp');
            modal.current.classList.add('animate__fadeOutDown');
            modal.current.classList.add('animate__animated');
        }

        setTimeout(() => {
            dispatch(setModalQR(null));
        }, 1e3);
    }

    return (
        <>
            <div className="blur animate__animated animate__fadeIn" ref={blur} onClick={e => closeHandler()}></div>
            <div className="modal modal-details animate__animated animate__fadeInUp" ref={modal}>
                <div className="modal-header">
                    <div className="title">{data.title}</div>
                    <div className="close" onClick={e => closeHandler()}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#1E1F1F"/>
                            <path d="M15 25.8483L25.8483 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M25.8483 25.8483L15 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div className="bitcoin_qr">
                    <img src={`${window.location.origin}/qr/${data.network}/${data.address}`}/>
                </div>
            </div>
        </>
    )    
}